import { toSafeWhitespaceString as toSafeString } from '@shared/utils';
import resolveMainThreadHeaderRouteContext from '@/lib/routes/resolveMainThreadHeaderRouteContext.js';
import { pathname, activeAutomationsPane } from '@/redux/selectors/uiSelectors.js';
import { threadMetaById } from '@/redux/selectors/pieveSelectors/baseSelectors.js';
import { threadItems, scheduleThreads, triggerThreads } from '@/redux/selectors/pieveSelectors/sidebarThreadCollectionSelectors.js';

export const automationRouteFallbackTitle = (state) => {
  const routeContext = resolveMainThreadHeaderRouteContext({ activeAutomationsPane: activeAutomationsPane(state), pathname: pathname(state) });
  const automationRouteId = toSafeString(routeContext?.automationsRouteContext?.id);

  if (!automationRouteId) {
    return '';
  }

  const scheduleThreadList = scheduleThreads(state);
  const scheduleThread = Array.isArray(scheduleThreadList) ? scheduleThreadList.find((t) => toSafeString(t?.id || t?.threadId) === automationRouteId) : null;
  if (scheduleThread?.title) {
    return toSafeString(scheduleThread.title);
  }

  const triggerThreadList = triggerThreads(state);
  const triggerThread = Array.isArray(triggerThreadList) ? triggerThreadList.find((t) => toSafeString(t?.id || t?.threadId) === automationRouteId) : null;
  if (triggerThread?.title) {
    return toSafeString(triggerThread.title);
  }

  const items = threadItems(state);
  const sidebarItem = Array.isArray(items) ? items.find((i) => toSafeString(i?.id) === automationRouteId) : null;
  if (sidebarItem?.label) {
    return toSafeString(sidebarItem.label);
  }

  return toSafeString(threadMetaById(state)?.[automationRouteId]?.title);
};
